import { Component, Input } from '@angular/core';
import { GlossaryService, GlossaryTerm } from '../../services/glossary.service';

/**
 * Icono ⓘ con tooltip didáctico. Reutiliza el sistema [data-tooltip] global.
 *
 * Uso por término del glosario:
 *   <app-info-tooltip term="p50"></app-info-tooltip>
 *
 * Uso con texto custom (no recomendado para términos repetidos):
 *   <app-info-tooltip text="Texto explicativo libre"></app-info-tooltip>
 *
 * Si se pasan ambos, prevalece `text`. Si no se pasa ninguno, no renderiza.
 */
@Component({
  selector: 'app-info-tooltip',
  templateUrl: './info-tooltip.component.html',
  styleUrls: ['./info-tooltip.component.scss']
})
export class InfoTooltipComponent {
  @Input() term?: GlossaryTerm;
  @Input() text?: string;

  /** Tamaño del icono en px. 12 por defecto, ajustable a 14 o 16 si hace falta más visible. */
  @Input() size: number = 12;

  constructor(private glossary: GlossaryService) {}

  get tooltipText(): string {
    if (this.text) return this.text;
    if (this.term) return this.glossary.getText(this.term);
    return '';
  }

  get hasContent(): boolean {
    return !!this.tooltipText;
  }
}
